// Copyright (c) 2026 Watch Tower Bible and Tract Society of Pennsylvania
// All Rights Reserved. Proprietary and confidential.
// Unauthorized copying, modification, or distribution is strictly prohibited.
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Share2, Download, MessageCircle, Mail, Loader2 } from 'lucide-react';

export default function ShareFormDialog({
  open,
  onOpenChange,
  formLabel,
  onDownload,
  onShareWhatsApp,
  email,
  setEmail,
  message,
  setMessage,
  sendingEmail,
  onSendEmail,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" data-testid="share-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Share2 className="w-5 h-5 text-primary" />
            Compartilhar Relatório
          </DialogTitle>
          <DialogDescription>
            Escolha como deseja compartilhar o relatório {formLabel}
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div className="grid grid-cols-2 gap-3">
            <Button
              variant="outline"
              className="h-auto py-4 flex flex-col gap-2"
              onClick={onDownload}
              data-testid="share-download-btn"
            >
              <Download className="w-6 h-6 text-blue-500" />
              <span className="text-sm font-medium">Baixar PDF</span>
            </Button>
            <Button
              variant="outline"
              className="h-auto py-4 flex flex-col gap-2"
              onClick={onShareWhatsApp}
              data-testid="share-whatsapp-btn"
            >
              <MessageCircle className="w-6 h-6 text-green-500" />
              <span className="text-sm font-medium">WhatsApp</span>
            </Button>
          </div>
          <div className="border-t border-border pt-4">
            <p className="text-sm font-medium text-foreground mb-3 flex items-center gap-2">
              <Mail className="w-4 h-4" /> Enviar por Email
            </p>
            <div className="space-y-3">
              <div>
                <Label className="text-sm">Email do destinatário</Label>
                <Input
                  type="email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  placeholder="exemplo@email.com"
                  className="mt-1"
                  data-testid="share-email-input"
                />
              </div>
              <div>
                <Label className="text-sm">Mensagem (opcional)</Label>
                <textarea
                  value={message}
                  onChange={e => setMessage(e.target.value)}
                  placeholder="Adicione uma mensagem..."
                  className="w-full mt-1 px-3 py-2 text-sm rounded-md border border-input bg-background text-foreground resize-y min-h-[60px]"
                  data-testid="share-message-input"
                />
              </div>
              <Button
                onClick={onSendEmail}
                disabled={sendingEmail}
                className="w-full"
                data-testid="send-email-btn"
              >
                {sendingEmail ? (
                  <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                ) : (
                  <Mail className="w-4 h-4 mr-2" />
                )}
                {sendingEmail ? 'Enviando...' : 'Enviar Email'}
              </Button>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
